import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { POPUP_MESSAGE, POPUP_TYPE } from '@Root/contants/popup'

export type PopupState = {
  key: POPUP_TYPE
  title: string
  text?: string
}

const initialState = {
  key: POPUP_TYPE.NONE,
  title: '',
  text: '',
}

const popupSlice = createSlice({
  name: 'popup/alarm',
  initialState,
  reducers: {
    changePopup: (state: PopupState, action: PayloadAction<Pick<PopupState, 'key'>>) => {
      const result = POPUP_MESSAGE[action.payload.key]

      state.key = action.payload.key
      state.title = result.title
      state.text = result.text
    },
  },
})

export const { changePopup } = popupSlice.actions
export default popupSlice.reducer
